import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

export default function ChecklistIntervention({ T, intervention, onClose, onCompleted }) {
  const [checklist, setChecklist] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [items, setItems] = useState([]);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(()=>{
    load();
    fetch(`${BASE}/checklists/templates`,{headers:h()}).then(r=>r.json()).then(d=>setTemplates(Array.isArray(d)?d:[]));
  },[]);

  const MODELE_TO_TEMPLATE = {
    pack_sentinelle: "Installation Vidéosurveillance - CHK-VIDEO-001",
    pack_flash: "Installation Pack Flash Control",
    maintenance: "Maintenance préventive",
    depannage: "Dépannage SAV",
  };

  const load = async () => {
    const res = await fetch(`${BASE}/checklists/${intervention.id}`,{headers:h()}).then(r=>r.json()).catch(()=>null);
    if (res && res.items) {
      setChecklist(res);
      const parsed = typeof res.items==="string" ? JSON.parse(res.items) : (res.items||[]);
      setItems(parsed);
    } else {
      // Pas de checklist existante — charger le bon template auto
      const tmplName = MODELE_TO_TEMPLATE[intervention.modele_pv];
      if(tmplName) {
        const tmpls = await fetch(`${BASE}/checklists/templates`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
        const tmpl = tmpls.find(t=>t.nom===tmplName);
        if(tmpl) {
          const parsed = typeof tmpl.items==="string" ? JSON.parse(tmpl.items) : tmpl.items;
          setItems(parsed.map(i=>({...i,valeur:null})));
          setSelectedTemplate(tmpl.id);
        }
      }
    }
  };

  const loadTemplate = (templateId) => {
    const tmpl = templates.find(t=>t.id===templateId);
    if (!tmpl) return;
    const parsed = typeof tmpl.items==="string" ? JSON.parse(tmpl.items) : tmpl.items;
    setItems(parsed.map(i=>({...i,valeur:false})));
    setSelectedTemplate(templateId);
  };

  const toggleItem = (idx) => {
    setItems(p=>p.map((item,i)=>i===idx?{...item,valeur:!item.valeur}:item));
  };

  const save = async (final=false) => {
    setSaving(true);
    const res = await fetch(`${BASE}/checklists/${intervention.id}`,{
      method:"POST",headers:h(),
      body:JSON.stringify({template_id:selectedTemplate||checklist?.template_id,items,final})
    });
    setSaving(false);
    // BUG-04 — le backend peut désormais refuser une clôture incomplète (422) même si
    // le garde-fou UI a été contourné : on ne clôture que si le serveur a accepté.
    if (final && res && res.ok === false) {
      let msg = "Check-list incomplète : items obligatoires non cochés";
      try { const d = await res.json(); if (d?.error) msg = d.error; } catch {}
      alert("⚠️ "+msg);
      return;
    }
    if (final) {
      onCompleted&&onCompleted();
      onClose();
    } else {
      setSaved(true);
      setTimeout(()=>setSaved(false),2000);
      load();
    }
  };

  const obligatoires = items.filter(i=>i.obligatoire);
  const obligatoiresOK = obligatoires.filter(i=>i.valeur===true);
  const total = items.length;
  const done = items.filter(i=>i.valeur===true).length;
  const pct = total>0?Math.round(done/total*100):0;
  const canClose = obligatoires.length===0 || obligatoiresOK.length===obligatoires.length;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1001,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:560,maxHeight:"90vh",display:"flex",flexDirection:"column"}}>

        {/* Header */}
        <div style={{padding:"18px 22px 14px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:T.text}}>☑️ Check-list opérationnelle</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>{intervention.titre}</div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
        </div>

        {/* Progression */}
        <div style={{padding:"12px 22px",borderBottom:`1px solid ${T.border}`,flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:T.muted,marginBottom:6}}>
            <span>{done} / {total} items cochés</span>
            <span style={{fontWeight:700,color:pct===100?T.success:T.accent}}>{pct}%</span>
          </div>
          <div style={{height:8,background:T.border,borderRadius:4,overflow:"hidden"}}>
            <div style={{height:"100%",width:`${pct}%`,background:pct===100?T.success:T.accent,borderRadius:4,transition:"width 0.3s"}}/>
          </div>
          {!canClose&&<div style={{fontSize:11,color:T.danger,marginTop:6,fontWeight:600}}>⚠️ {obligatoires.length-obligatoiresOK.length} item(s) obligatoire(s) non cochés — requis pour clôturer</div>}
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"14px 22px"}}>
          {/* Sélecteur template si pas de checklist */}
          {!checklist&&items.length===0&&(
            <div style={{marginBottom:16}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:8}}>Choisir un modèle de check-list</div>
              <div style={{display:"flex",flexDirection:"column",gap:8}}>
                {templates.map(t=>(
                  <div key={t.id} onClick={()=>loadTemplate(t.id)}
                    style={{padding:"11px 14px",borderRadius:12,border:`1.5px solid ${selectedTemplate===t.id?T.accent:T.border}`,background:selectedTemplate===t.id?T.accentDim:"transparent",cursor:"pointer"}}>
                    <div style={{fontSize:13,fontWeight:700,color:selectedTemplate===t.id?T.accent:T.text}}>{t.nom}</div>
                    <div style={{fontSize:11,color:T.muted}}>{typeof t.items==="string"?JSON.parse(t.items).length:t.items?.length||0} items</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Items */}
          {items.map((item,idx)=>(
            <div key={item.id||idx} onClick={()=>toggleItem(idx)}
              style={{display:"flex",alignItems:"center",gap:12,padding:"11px 14px",borderRadius:12,marginBottom:6,background:item.valeur?`${T.success}10`:T.bg,border:`1px solid ${item.valeur?T.success+"40":T.border}`,cursor:"pointer",transition:"all 0.15s"}}>
              <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${item.valeur?T.success:T.border}`,background:item.valeur?T.success:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all 0.15s"}}>
                {item.valeur&&<span style={{color:"#fff",fontSize:13,fontWeight:800}}>✓</span>}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:13,fontWeight:item.obligatoire?700:500,color:T.text}}>{item.label}</div>
                {item.obligatoire&&<div style={{fontSize:10,color:T.danger,fontWeight:600,marginTop:1}}>★ Obligatoire</div>}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{padding:"12px 22px",borderTop:`1px solid ${T.border}`,display:"flex",gap:10,flexShrink:0}}>
          <button onClick={()=>save(false)} disabled={saving||items.length===0}
            style={{flex:1,padding:"11px",borderRadius:11,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,fontWeight:600,cursor:"pointer"}}>
            {saved?"✅ Sauvegardé":"💾 Sauvegarder"}
          </button>
          <button onClick={()=>save(true)} disabled={saving||!canClose||items.length===0}
            style={{flex:2,padding:"11px",borderRadius:11,background:canClose&&items.length>0?`linear-gradient(135deg,${T.success},#16a34a)`:T.border,border:"none",color:"#fff",fontSize:14,fontWeight:700,cursor:canClose?"pointer":"not-allowed"}}>
            {saving?"...":"✅ Valider la check-list"}
          </button>
        </div>
      </div>
    </div>
  );
}
